<template>
  <div>
    <div class="title">
      <i class="icon countdown"></i>
      <span>{{ flash_titie }}</span>
    </div>
    <div v-if="countdownShow" class="timeBox">
    <span class="value">{{ pageData.hour }}</span
    ><span class="label">:</span>
      <span class="value">{{ pageData.minute }}</span
      ><span class="label">:</span>
      <span class="value">{{ pageData.second }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'countdown',
  props: {
    flashSaleInfo: {
      type: Object,
    },
  },
  data() {
    return {
      countdownShow: true,
      pageData: {
        day: '0',
        hour: '00',
        minute: '00',
        second: '00',
      },
      flash_titie: '',
    };
  },
  created() {
    this.interval = setInterval(() => {
      this.flash_titie = this.flashTitie();
      if (!this.flashSaleInfo.store) {
        clearInterval(this.interval);
        return;
      }
      let endTime = 0;
      if (new Date().getTime() < this.flashSaleInfo.startTime) {
        endTime = (this.flashSaleInfo.startTime / 1000) - (new Date().getTime() / 1000);
      } else {
        endTime = (this.flashSaleInfo.endTime / 1000) - (new Date().getTime() / 1000);
      }
      if (endTime < 0) {
        clearInterval(this.interval);
        return;
      }
      const date = {
        day: Math.floor(endTime / 86400),
        hour: Math.floor((endTime % 86400) / 3600),
        minute: Math.floor((endTime % 3600) / 60),
        second: Math.floor((endTime % 3600) % 60),
      };

      Object.keys(date).forEach((value) => {
        if (date[value].toString().length < 2 && value !== 'day') {
          this.pageData[value] = `0${date[value]}`;
        } else {
          this.pageData[value] = date[value];
        }
      });
    }, 1000);
  },
  methods: {
    flashTitie() {
      if (!_.isEmpty(this.flashSaleInfo)) {
        const {
          flashSaleInfo: {
            startTime, endTime, store,
          },
        } = this;
        if (!store) {
          return '活动已结束';
        }
        if (new Date().getTime() < startTime) {
          return '距开始还剩：';
        } else if (new Date().getTime() > startTime && new Date().getTime() < endTime) {
          return '距结束还剩：';
        }
        return '活动已结束';
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style lang="scss">
.title {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-top: 5px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  font-weight: 400;
  color: rgba(240, 96, 1, 1);

  .countdown {
    vertical-align: middle;
    margin-right: 3px;
  }
}

.timeBox {
  .label {
    display: inline-block;
    text-align: center;
    width: 15px;
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(240, 96, 0, 1);
    line-height: 30px;
  }

  .value {
    display: inline-block;
    width: 43px;
    height: 43px;
    border-radius: 5px;
    font-size: 30px;
    line-height: 43px;
    font-family: PingFangSC-Medium;
    font-weight: Medium;
    color: rgba(255, 255, 255, 1);
    background-color: #ff5f00;
    text-align: center;
  }
}
</style>
